import Vue from "vue";
import store from "@/store";
import Router from "vue-router";
import Login from "@/components/TheLogin.vue";

// Dash Views
import Dashboard from "@/views/Dashboard";
import News from "@/views/News";

import Purchase from "@/views/Purchase";

import Planning from "@/views/Planning";
import PlanningAdd from "@/views/PlanningAdd";

import EvidenceView from "@/views/EvidenceView";

import Contact from "@/views/Contact";

import UnitView from "@/views/UnitView";

import Events from "@/views/Events";
import EventView from "@/views/EventView";

import Activities from "@/views/Activities";
import ActivityView from "@/views/ActivityView";


import Onboarding from "@/views/Onboarding";

import MyAccount from "@/views/MyAccount";

import Subjects from "@/views/Subjects";

import CPD from "@/views/Development";

/////////////////////////
///////  DANCE
/////////////////////////

import Dance from "@/views/Dance";
import DanceHome from "@/views/dance/Home";
import DanceCPD from "@/views/dance/CPD";
import DanceEC from "@/views/dance/Extra";
import DanceResources from "@/views/dance/Resources";




/////////////////////////
///////  Swimming
/////////////////////////
import Swimming from "@/views/Swimming";
import SwimResources from "@/views/swimming/Resources";
import SwimVideos from "@/views/swimming/Videos";
import SwimCurriculum from "@/views/swimming/Curriculum";
import SwimEngland from "@/views/swimming/Swimengland";

/////////////////////////
///////  MY CONTENT
/////////////////////////
import MyContent from "@/views/MyContent";
import CustomUnits from "@/views/mycontent/CustomUnits";
import CustomUnit from "@/views/mycontent/CustomUnit";
import Outcomes from "@/views/mycontent/Outcomes";
import PlanningOutcomes from "@/views/mycontent/PlanningOutcomes";
import OutcomeEdit from "@/views/mycontent/OutcomeEdit";
import Community from "@/views/mycontent/Community";

/////////////////////////
///////  TOOLBOX
/////////////////////////
import Toolbox from "@/views/Toolbox";
import Crews from "@/views/toolbox/Crews";
import CrewView from "@/views/toolbox/CrewView";
import Clubs from "@/views/toolbox/Clubs";
import ClubView from "@/views/toolbox/ClubView";
import AfpeReport from "@/views/toolbox/AfpeReport";
import Pupils from "@/views/toolbox/Pupils";
import PupilEdit from "@/views/toolbox/PupilEdit";

/////////////////////////
///////  Library
/////////////////////////
import Library from "@/views/Library";
import Resources from "@/views/library/Resources";
import Videos from "@/views/library/Videos";
import HealthEducation from "@/views/library/Education";
import HealthContent from '@/views/library/Content';

/////////////////////////
///////  Pupil Voice
/////////////////////////
import Wellbeing from "@/views/Wellbeing";
import WellbeingPupils from "@/views/wellbeing/WellbeingPupils";
import WellbeingQuestions from "@/views/wellbeing/WellbeingQuestions";
import WellbeingAnswers from "@/views/wellbeing/WellbeingAnswers";


/////////////////////////
///////  Reports
/////////////////////////
import Reports from "@/views/Reports";
import OrgSchoolReportList from "@/views/OrgSchoolReportList"
import OrgSchoolReport from "@/views/OrgSchoolReport"
import OrgSchools from "@/views/OrgSchools";
import ReportOverview from "@/views/reporting/ReportOverview";
import ReportBreakdown from "@/views/reporting/ReportBreakdown";
import ReportAssessment from "@/views/reporting/ReportAssessment";
import ReportEvents from "@/views/reporting/ReportEvents";
import ReportExtraCurricular from "@/views/reporting/ReportExtraCurricular";
import ReportTimeline from "@/views/reporting/ReportTimeline";
import EvidenceArchive from "@/views/reporting/EvidenceArchive";
import TimelineView from "@/views/reporting/TimelineView";


/////////////////////////
///////  SETTINGS
/////////////////////////
import Settings from "@/views/Settings";
import Support from "@/views/settings/Support";
import Users from "@/views/settings/Users";
import Configuration from "@/views/settings/Configuration";
import AssessmentSettings from "@/views/settings/Assessment";
import Rooms from "@/views/settings/Rooms";
import Classes from "@/views/settings/Classes";

/////////////////////////
///////  SETTINGS DISPLAY
/////////////////////////
import DisplayYearGroups from "@/views/settings/display/YearGroups";
import DisplayFields from "@/views/settings/display/Fields";
import DisplayPlanning from "@/views/settings/display/Planning";

/////////////////////////
///////  SETTINGS ASSESSMENT
/////////////////////////
import AssessmentGeneral from "@/views/settings/assessment/General";
import AssessmentCriteria from "@/views/settings/assessment/Criteria";
import AssessmentGrades from "@/views/settings/assessment/Grades";



/////////////////////////
///////  HEALTH
/////////////////////////
import Health from "@/views/Health";
import HealthMeasures from "@/views/health/Measures";
import HealthPupilMeasures from "@/views/health/PupilMeasures";
import HealthMeasureWorkout from "@/views/health/MeasureWorkout"
import TaskGroups from "@/views/health/TaskGroups";
import Tasks from "@/views/health/Tasks";

/////////////////////////
///////  Challenges
/////////////////////////
import Challenges from "@/views/health/challenge/Challenges";
import ChallengePupils from "@/views/health/challenge/ChallengePupils";

////////////////////////
///////  Max Whitlock
/////////////////////////

import MaxWhitlock from "@/views/Maxwhitlock";
import MaxWhitlockHome from "@/views/maxwhitlock/Home";
import MaxWhitlockResources from "@/views/maxwhitlock/Resources";
import MaxWhitlockVideos from "@/views/maxwhitlock/Videos";
import MaxWhitlockEC from "@/views/maxwhitlock/Extra";

import Ping from "@/views/Ping";
import MaintenanceMode from "@/views/Maintenance";

/////////////////
///////  Notices
/////////////////
import NoticesAdmin from '@/views/Notices'
import NoticeEdit from "@/views/NoticeEdit";


/////////////////
///////  ADMIN
/////////////////
import SchoolsAdmin from '@/views/admin/Schools'
import RegistersAdmin from '@/views/admin/Registers'
import ResourceAdminLibrary from '@/views/admin/ResourceLibrary'
import ResourceAdmin from '@/views/admin/ResourceAdmin'

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/admin/schools-admin',
      name: 'SchoolsAdmin',
      component: SchoolsAdmin,
    },
    {
      path: '/admin/resource-library',
      name: 'ResourceAdminLibrary',
      component: ResourceAdminLibrary,
    },
    {
      path: '/admin/resource-admin',
      name: 'ResourceAdmin',
      component: ResourceAdmin,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      },
    },
    {
      path: '/admin/registers-admin',
      name: 'RegistersAdmin',
      component: RegistersAdmin,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      },
    },

    //   { path: '*', component: MaintenanceMode,
    //   meta: {
    //     loginLayout: true,
    //     hideHeader: true
    //   }
    //  },
    //   { path: '/*', component: MaintenanceMode,
    //   meta: {
    //     loginLayout: true,
    //     hideHeader: true
    //   }
    //  },
    {
      path: "/ping",
      name: "Ping",
      component: Ping,
      meta: {
        loginLayout: true,
        hideHeader: true
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
      meta: {
        loginLayout: true,
        hideHeader: true
      }
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      component: Onboarding,
      meta: {
        loginLayout: true,
        hideHeader: true
      }
    },
    {
      path: "/account",
      name: "MyAccount",
      component: MyAccount,
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: false,
         hideHeader: true
      },
    },
    {
      path: "/subjects",
      name: "Subjects",
      component: Subjects,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: false
      }
    },
    {
      path: '/notices',
      name: 'NoticesAdmin',
      component: NoticesAdmin
    },
    {
      path: "/notice",
      component: NoticeEdit,
      name: "NoticeEdit",
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true,
        hideHeader: true
      }
    },
    {
      path: "/planning",
      name: "Planning",
      component: Planning,
      meta: {
        requiresAuth: true,
        hideFromOrg: true,
        title: "Long Term Planning",
        showSide: true
      }
    },
    {
      path: "/planning-add",
      name: "PlanningAdd",
      component: PlanningAdd,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/evidence",
      name: "EvidenceView",
      component: EvidenceView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        title: "PE Passport online",
        showSide: true
      }
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        requiresAuth: true,
        title: "PE Passport online",
        showSide: false,
         hideHeader: true
      }
    },
    {
      path: "/my-content",
      name: "MyContent",
      component: MyContent,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          component: CustomUnits, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'custom-units',
          component: CustomUnits,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "custom-outcomes",
          component: Outcomes,
          props: true,
          meta: {
            requiresAuth: true,
            hasUnitsAccess: true,
          }
        },
        {
          path: "planning-outcomes",
          component: PlanningOutcomes,
          props: true,
          meta: {
            requiresAuth: true,
            hasUnitsAccess: true,
          }
        },
      ]
    },
    {
      path: "custom-unit",
      component: CustomUnit,
      name: "CustomUnit",
      props: true,
      meta: {
        hideHeader: true,
        requiresAuth: true,
        showSide: false
      }
    },
    {
      path: "custom-outcome",
      component: OutcomeEdit,
      name: "OutcomeEdit",
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: false,
        hideHeader: true
      }
    },
    {
      path: "/store",
      name: "Purchase",
      component: Purchase,
      meta: {
        requiresAuth: true,
        title: "Purchase Units"
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        requiresAuth: true,
        title: "Contact Us"
      }
    },
    {
      path: "/wellbeing",
      name: "Wellbeing",
      component: Wellbeing,
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: WellbeingPupils, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'wellbeing-pupils',
          component: WellbeingPupils,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: "/library",
      name: "Library",
      component: Library,

      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: Resources, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'documents',
          component: Resources,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'videos',
          component: Videos,
          meta: {
            requiresAuth: true,
          }
        },
                {
          path: "education",
          name: "HealthEducation",
          component: HealthEducation,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: "/toolbox",
      name: "Toolbox",
      component: Toolbox,

      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: Pupils, // default child path
          meta: {
            requiresAuth: true,
          }
        },
            {
      path: 'pupils',
      component: Pupils,
      name: "Pupils",
      meta: {
        requiresAuth: true,
      }
    },
        {
          path: 'crews',
          component: Crews,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'clubs',
          component: Clubs,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: "/crew-view",
      name: "CrewView",
      component: CrewView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/club-view",
      name: "ClubView",
      component: ClubView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/taskgroup-view",
      name: "Tasks",
      component: Tasks,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/afpe-report",
      name: "AfpeReport",
      component: AfpeReport,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/wellbeing",
      name: "WellbeingQuestions",
      component: WellbeingQuestions,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/wellbeing-answers",
      name: "WellbeingAnswers",
      component: WellbeingAnswers,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    
    {
      path: "/swimming",
      name: "Swimming",
      component: Swimming,
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: SwimResources, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'documents',
          component: SwimResources,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'videos',
          component: SwimVideos,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'curriculum',
          component: SwimCurriculum,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'swimengland',
          component: SwimEngland,
          meta: {
            requiresAuth: true,
          }
        }
      ]
    },
    {
      path: "/unit-view",
      name: "UnitView",
      component: UnitView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: Configuration, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'support',
          component: Support,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'users',
          component: Users,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'rooms',
          component: Rooms,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'classes',
          component: Classes,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "/settings/assessment",
          name: "AssessmentSettings",
          component: AssessmentSettings,
          props: true,
          meta: {
            requiresAuth: true,
            hasUnitsAccess: true,
            showSide: true
          },
          children: [
            {
              path: '',
              component: AssessmentGeneral, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'general',
              component: AssessmentGeneral, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'criteria',
              component: AssessmentCriteria, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'grades',
              component: AssessmentGrades, // default child path
              meta: {
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: "/settings/configuration",
          name: "Configuration",
          component: Configuration,
          props: true,
          meta: {
            requiresAuth: true,
            hasUnitsAccess: true,
            showSide: true
          },
          children: [
            {
              path: '',
              component: DisplayPlanning, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'fields',
              component: DisplayFields, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'yeargroups',
              component: DisplayYearGroups, // default child path
              meta: {
                requiresAuth: true,
              }
            },
            {
              path: 'planning',
              component: DisplayPlanning, // default child path
              meta: {
                requiresAuth: true,
              }
            },
          ]
        },
      ]
    },
    {
      path: '/pupil',
      component: PupilEdit,
      name: "PupilEdit",
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/events",
      name: "Events",
      component: Events,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/event",
      name: "EventView",
      component: EventView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/reports",
      name: "Reports",
      component: Reports,
      meta: {
        requiresAuth: true,
        title: "Reports",
      },
      children: [
        {
          path: '',
          component: ReportOverview, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-overview',
          component: ReportOverview,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-assessments',
          component: ReportAssessment,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-breakdown',
          component: ReportBreakdown,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-events',
          component: ReportEvents,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-extracurricular',
          component: ReportExtraCurricular,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'report-timeline',
          component: ReportTimeline,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'evidences',
          component: EvidenceArchive,
          meta: {
            requiresAuth: true,
          }
        }
      ]
    },
    {
      path: "timeline-view",
      name: "TimelineView",
      component: TimelineView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    
    {
      path: "/school-report-list",
      name: "OrgSchoolReportList",
      component: OrgSchoolReportList,
      meta: {
        requiresAuth: true,
        title: "School Reports",
      }
    },
    {
      path: "/school-report",
      name: "OrgSchoolReport",
      component: OrgSchoolReport,
      props: true,
      meta: {
        requiresAuth: true,
        title: "School Reports",
        hideHeader: true
      }
    },
    {
      path: "/health",
      name: "Health",
      component: Health,

      props: true,
      meta: {
        requiresAuth: true,
        hasUnitsAccess: true,
        showSide: true
      },
      children: [
        {
          path: '',
          component: HealthMeasures, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "measures",
          name: "HealthMeasures",
          component: HealthMeasures,
          meta: {
            requiresAuth: true,
            title: "Health Measures",
          }
        },
        {
          path: "pupil-measures",
          name: "HealthPupilMeasures",
          component: HealthPupilMeasures,
          props: true,
          meta: {
            requiresAuth: true,
            hideHeader: false
          }
        },
                {
          path: 'taskgroups',
          component: TaskGroups,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "challenges",
          name: "Challenges",
          component: Challenges,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: "health-content",
      name: "HealthContent",
      component: HealthContent,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/measures/workout",
      name: "HealthMeasureWorkout",
      component: HealthMeasureWorkout,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/schools",
      name: "OrgSchools",
      component: OrgSchools,
      meta: {
        requiresAuth: true,
        title: "OrgSchools",
        subnav: "config",
        showSide: false
      }
    },
    {
      path: "/activities",
      name: "Activities",
      component: Activities,
      meta: {
        requiresAuth: true,
        title: "Extra Currciular"
      }
    },
    {
      path: "/activity",
      name: "ActivityView",
      component: ActivityView,
      props: true,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/community",
      name: "Community",
      component: Community,
      meta: {
        requiresAuth: true,
        title: "Community Units"
      }
    },

    {
      path: "/challenges-pupils",
      name: "ChallengePupils",
      component: ChallengePupils,
      meta: {
        requiresAuth: true,
        hideHeader: true
      }
    },
    {
      path: "/dance",
      name: "Dance",
      component: Dance,
      meta: {
        requiresAuth: true,
        hideFromOrg: false,
      },
         children: [
        {
          path: '',
          component: DanceHome, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'overview',
          component: DanceHome, // default child path
          meta: {
            requiresAuth: true,
          }
        },
               {
          path: "documents/:type",
          name: "DanceResources",
          component: DanceResources,
          meta: {
            requiresAuth: true,
          }
        },
             {
          path: "cpd",
          name: "DanceCPD",
          component: DanceCPD,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "extra",
          name: "DanceEC",
          component: DanceEC,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: "/maxwhitlock",
      name: "MaxWhitlock",
      component: MaxWhitlock,
      meta: {
        requiresAuth: true,
        hideFromOrg: false,
      },
      children: [
        {
          path: '',
          component: MaxWhitlockHome, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'overview',
          component: MaxWhitlockHome, // default child path
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "documents/:type",
          name: "MaxWhitlockResources",
          component: MaxWhitlockResources,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "videos/:type",
          name: "MaxWhitlockVideos",
          component: MaxWhitlockVideos,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "extra",
          name: "MaxWhitlockEC",
          component: MaxWhitlockEC,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
  ]
});


///////////////////////////////////
// CHECKS ROUTES FOR VALID META //
//////////////////////////////////

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // check token

    if (store.getters.isLoggedIn == false) {
      if (to.matched.some(record =>record.path != "/login")) {
        try {
          next({
            path: "/login",
            params: { nextUrl: to.fullPath }
          });
        } catch (error) {
          if (!(error instanceof NavigationDuplicated)) {
            throw error;
          }
        }
      }



    } else {
      if (to.matched.some(record => record.meta.hideFromOrg)) {
        if (store.getters.currentUser.isSchool == false) {
          next({ path: "/dashboard" });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

if (process.env.NODE_ENV != 'development') {
  // raygun monitor on route change
  router.afterEach((to, from) => {
    rg4js('trackEvent', {
      type: 'pageView',
      path: to.path
    });
  })
}
export default router;
